export const profileConstants = {
  GET_PROFILE_IMAGE_URL: "GET_PROFILE_IMAGE_URL",
  GET_PROFILE_DATA: "GET_PROFILE_DATA",
  UPDATE_PROFILE_DATA: "UPDATE_PROFILE_DATA",
  UPLOAD_PROFILE_PIC: "UPLOAD_PROFILE_PIC",
  UPDATE_PROFILE_STATE: "UPDATE_PROFILE_STATE",
  GET_ACTIVE_PROFILE: "GET_ACTIVE_PROFILE",
};

export const profileTabConstants = {
  PROFILE: 0,
  QUALIFICATIONS: 1,
  PAYMENT: {
    verified: 1,
    sailor: 2,
  },
};

export const sidebarCertificatesTabIndex = {
  Sailor: 0,
  Instructor: 1,
};
